<template>
    <span class="bracket">
        <span
            ref="bracketLabel"
            :class="{
                'bracket-label': bracket.isConfirmed,
                'predicted-bracket--label': !bracket.isConfirmed
            }"
        >
            {{entityName}}
        </span>
        <span
            ref="role"
            v-if="entityRole"
            class="bracket-role"
        >
            :{{entityRole}}
        </span>
        }
        <or-popover
            v-if="entityRole"
            ref="rolePopover"
            position="bottom right"
            trigger="role"
            @open="eventHandlerOpen"
        >
           <div>
               <or-button
                   class="entity-delete-btn"
                   type="secondary"
                   color="red"
                   @click="deleteRole"
               >
                 {{ $t('common.utterance.entity-token.entity_label.removeRole') }}
               </or-button>
           </div>
        </or-popover>
        <or-popover
            ref="labelPopover"
            position="bottom right"
            trigger="bracketLabel"
            @open="eventHandlerOpen"
        >
            <div v-if="!bracket.virtual && bracket.isConfirmed && allowMapRoles">
                <div class="entity-role--header">
                  {{ $t('common.utterance.entity-token.entity_label.roles') }}
                </div>
                <div v-if="!allEntities.loading">
                    <div
                        v-for="role in roles"
                        class="entity-role--item"
                        :class="{selected: role === selectedRole}"
                        :key="role"
                        @click="selectRole(role)"
                    >
                        {{role}}
                    </div>
                </div>
                <div v-else>
                  {{ $t('common.utterance.entity-token.entity_label.rolesUploading') }}
                </div>
            </div>

            <div
                v-if="!allowMapRoles"
                class="entity-role--header"
            >
              {{ $t('common.utterance.entity-token.entity_label.youShouldRetrain') }}
            </div>

            <div class="divider" />
            <or-button
                v-if="bracket.type !== 'auto'"
                class="entity-delete-btn"
                type="secondary"
                color="red"
                @click="deleteEntity"
            >
              {{ $t('common.utterance.entity-token.entity_label.removeEntity') }}
            </or-button>
            <div
                v-else
                class="entity-auto-description"
            >
              {{ $t('common.utterance.entity-token.entity_label.itWasAutomatically', { '1': bracket.entity }) }}
            </div>
        </or-popover>
    </span>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    bracket: Object,
    entities: Array
  },

  computed: {
    ...mapState('knowledgebase/entities', ['allEntities']),

    allowMapRoles () {
      return this.$props.bracket.hasPositionIndex || this.$props.bracket.type !== 'auto'
    },

    roles () {
      const selectedEntity = this.allEntities.value.find(entity => entity.name === this.$props.bracket.entity)
      // backward compatibility with old entities
      return (selectedEntity ? selectedEntity.roles : []) || []
    },

    entityRole () {
      return this.bracket.role || ''
    },

    entityName () {
      return this.bracket.entity || this.bracket.name
    },

    selectedRole () {
      return this.bracket.role
    }
  },

  methods: {
    deleteEntity () {
      this.$emit('remove-entity', this.bracket)
      this.$refs.labelPopover.close()
    },

    deleteRole () {
      this.$emit('selectRole', this.bracket, null)
      this.$refs.rolePopover.close()
    },

    eventHandlerOpen () {
      this.$emit('open')
    },

    selectRole (role) {
      this.$emit('selectRole', this.bracket, role)
    }
  }
}
</script>

<style lang="scss" scoped>
    .entity-role--btn {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .entity-role--header {
        font-size: 14px;
        padding: 8px;
        color: rgb(145, 150, 157);
    }

    .entity-role--item {
        font-size: 14px;
        padding: 8px;
        cursor: pointer;
        &:hover {
            background-color: rgb(246, 246, 246);
        }
    }

    .divider {
        height: 1px;
        width: 100%;
        background-color: rgb(196, 196, 196);
    }

    .entity-delete-btn {
        font-size: 14px;
        border: 0;
        border-radius: 0;
        padding: 8px;
    }

    .entity-auto-description {
        max-width: 300px;
        font-size: 14px;
        padding: 8px;
        color: rgb(145, 150, 157);
    }

    .bracket {
        font-size: 14px;
        font-weight: bold;

        .predicted-bracket--label {
            border-style: solid;
            border-width: 1px;
            border-radius: 3px;
            margin: 0 3px;
            padding: 2px 4px;
            font-size: 14px;
            font-weight: normal;
        }

        .bracket-label {
            color: white;
            word-break: normal;
            border-radius: 3px;
            margin: 0 3px;
            padding: 2px 4px;
            font-size: 14px;
            font-weight: normal;
        }

        &.green{
            color: darkgreen;
            .bracket-label{
                color: white;
                background-color: darkgreen;
            }
        }

        &.red{
            color: darkred;
            .bracket-label{
                color: white;
                background-color: darkred;
            }
        }

        &.yellow{
            color: darkorange;
            .bracket-label{
                color: white;
                background-color: darkorange;
            }
        }

        &.lightcoral{
            color: lightcoral;
            .bracket-label{
                color: white;
                background-color: lightcoral;
            }
        }

        &.yellowgreen{
            color: yellowgreen;
            .bracket-label{
                color: white;
                background-color: yellowgreen;
            }
        }

        &.hotpink{
            color: hotpink;
            .bracket-label{
                color: white;
                background-color: hotpink;
            }
        }

        &.sandybrown{
            color: sandybrown;
            .bracket-label{
                color: white;
                background-color: sandybrown;
            }
        }

        &.chocolate{
            color: chocolate;
            .bracket-label{
                color: white;
                background-color: chocolate;
            }
        }
    }
</style>
